import { Paragraph2, SmallText } from 'inpock-ui-react';

import { thumbnail } from '@/utils';
import { Thumbnail } from '@/components/common';

import * as S from './styled';

interface OrderItemProps {
  image: string;
  campaignName: string;
  orderlineName: React.ReactNode;
  price?: number;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  clickable?: boolean;
}

/**
 * 주문상세내역, 리뷰작성 페이지에서 활용
 */
export function OrderItem({
  image,
  campaignName,
  orderlineName,
  price,
  header,
  footer,
  clickable,
}: OrderItemProps) {
  return (
    <S.OrderItemWrapper clickable={clickable}>
      {header}
      <S.OrderItemBody>
        <Thumbnail src={thumbnail.small(image)} />
        <S.OrderItemContent>
          <Paragraph2 color="gray800" fontWeight="bold">
            {campaignName}
          </Paragraph2>
          {orderlineName}
          {price && (
            <S.OrderItemPrice>
              <SmallText>상품</SmallText>
              <div className="vertical-divider" />
              <SmallText className="text-bold">{price.toLocaleString()}원</SmallText>
            </S.OrderItemPrice>
          )}
        </S.OrderItemContent>
      </S.OrderItemBody>
      {footer}
    </S.OrderItemWrapper>
  );
}
